import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { loginPageTranslations } from './auth/loginPage';
import { fightHistoryStageTranslations } from './auth/fightHistoryStage';
import { fightersPageTranslations } from './fighters/fightersPageTranslations';
import { managersPageTranslations } from './managers/managersPageTranslations';
import { notificationsPageTranslations } from './notification/notificationTranslations';
import { sidebarTranslations } from './sidebar/sidebarTranslations';
import { settingsTranslations } from './settings/settingsTraslation';
import { viewProfileTranslations } from './viewProfile/viewProfileTranslation';
import { publicProfileTranslations } from './viewProfile/publicProfileTranslation';
import { dashboardTranslations } from './dashboard/dashboardTranslation';
import ReadyRosterTranslations from './fighters/ReadyRosterTranslations';
import { opportunitiesTranslations } from './managers/opportunitiesTranslations';
import { CreateEditReadyRosterTranslations } from './fighters/createEditReadyRosterTranslations';
import { createEditOpportunitiesTranslations } from './managers/createEditOpportunitiesTranslations';
import { reportAbusePopupTranslations } from './Report/reportAbusePopupTranslations';
import { historyTranslations } from './auth/history/historyTranslations';
import { editProfileStatusTranslations } from './viewProfile/profilestatus';
import { abuseReportTranslations } from './abusereport/abuseReport';
import { dealAccordionTranslations } from './deal/dealAcoordionTranslation';
import { updateProfileTranslations } from './viewProfile/updateProfileTranslations';
import { viewDealTranslations } from './deal/viewDealTranslations';
import { socialMediaSectionTranslations } from './viewProfile/socialMediaTranslations';
import { pendingListTranslations } from './Pending/pendingListTranslations ';
import { feedsTranslations } from './feed/feedsTranslations';
import { marketPlaceCardsTranslations } from './marketPlaceCards/marketPlaceCardsTranslations';


const resources = {
    en: {
        login: loginPageTranslations.en,
        fighthistory: fightHistoryStageTranslations.en,
        fighters: fightersPageTranslations.en,
        managers: managersPageTranslations.en,
        notifications: notificationsPageTranslations.en,
        sidebar: sidebarTranslations.en,
        settings: settingsTranslations.en,
        viewProfile: viewProfileTranslations.en,
        publicProfile: publicProfileTranslations.en,
        dashboard: dashboardTranslations.en,
        readyRoster: ReadyRosterTranslations.en,
        opportunities: opportunitiesTranslations.en,
        CreateEditReadyRoster: CreateEditReadyRosterTranslations.en,
        CreateEditOpportunities: createEditOpportunitiesTranslations.en,
        reportAbusePopup: reportAbusePopupTranslations.en,
        history: historyTranslations.en,
        viewDeal: viewDealTranslations.en,
        editProfileStatus: editProfileStatusTranslations.en,
        abusereport: abuseReportTranslations.en,
        dealAccordion: dealAccordionTranslations.en,
        updateProfile: updateProfileTranslations.en,
        socialMediaSection:socialMediaSectionTranslations.en,
        pending:pendingListTranslations.en,
        feeds:feedsTranslations.en,
        marketPlaceCards: marketPlaceCardsTranslations.en,
    },
    de: {
        login: loginPageTranslations.de,
        fighthistory: fightHistoryStageTranslations.de,
        fighters: fightersPageTranslations.de,
        managers: managersPageTranslations.de,
        notifications: notificationsPageTranslations.de,
        sidebar: sidebarTranslations.de,
        settings: settingsTranslations.de,
        viewProfile: viewProfileTranslations.de,
        publicProfile: publicProfileTranslations.de,
        dashboard: dashboardTranslations.de,
        readyRoster: ReadyRosterTranslations.de,
        opportunities: opportunitiesTranslations.de,
        CreateEditReadyRoster: CreateEditReadyRosterTranslations.de,
        CreateEditOpportunities: createEditOpportunitiesTranslations.de,
        reportAbusePopup: reportAbusePopupTranslations.de,
        history: historyTranslations.de,
        viewDeal: viewDealTranslations.de,
        editProfileStatus: editProfileStatusTranslations.de,
        abusereport: abuseReportTranslations.de,
        dealAccordion: dealAccordionTranslations.de,
        updateProfile: updateProfileTranslations.de,
        socialMediaSection:socialMediaSectionTranslations.de,
        pending:pendingListTranslations.de,
        feeds:feedsTranslations.de,
        marketPlaceCards: marketPlaceCardsTranslations.de,
    },
    hr: {
        login: loginPageTranslations.hr,
        fighthistory: fightHistoryStageTranslations.hr,
        fighters: fightersPageTranslations.hr,
        managers: managersPageTranslations.hr,
        notifications: notificationsPageTranslations.hr,
        sidebar: sidebarTranslations.hr,
        settings: settingsTranslations.hr,
        viewProfile: viewProfileTranslations.hr,
        publicProfile: publicProfileTranslations.hr,
        dashboard: dashboardTranslations.hr,
        readyRoster: ReadyRosterTranslations.hr,
        opportunities: opportunitiesTranslations.hr,
        CreateEditReadyRoster: CreateEditReadyRosterTranslations.hr,
        CreateEditOpportunities: createEditOpportunitiesTranslations.hr,
        reportAbusePopup: reportAbusePopupTranslations.hr,
        history: historyTranslations.hr,
        viewDeal: viewDealTranslations.hr,
        editProfileStatus: editProfileStatusTranslations.hr,
        abusereport: abuseReportTranslations.hr,
        dealAccordion: dealAccordionTranslations.hr,
        updateProfile: updateProfileTranslations.hr,
        socialMediaSection:socialMediaSectionTranslations.hr,
        pending:pendingListTranslations.hr,
        feeds:feedsTranslations.hr,
         marketPlaceCards: marketPlaceCardsTranslations.hr,
    },

};

const getUserLanguage = (): string => {
    const userJson = localStorage.getItem('loginResponse');
    const user = userJson ? JSON.parse(userJson) : null;
    return user?.preferredLanguage || "";
};


i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem(getUserLanguage() || 'i18nextLng') || 'en',
    fallbackLng: 'en',
    ns: ['login', 'dealAccordion', 'viewDeal', 'fighthistory', 'fighters', 'managers', 'notifications', 'sidebar', 'settings', 'viewProfile', 'publicProfile', 'dashboard', 'readyRoster', 'opportunities', 'updateProfile', 'CreateEditReadyRoster', 'CreateEditOpportunities', 'reportAbusePopup', 'history', 'editProfileStatus', 'abusereport', 'socialMediaSection', 'basicInfoSection','pending','feeds'],
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;

